export const MAX_SMALL_DEVICE_WIDTH = 551;
export const MAX_MEDIUM_DEVICE_WIDTH = 1200;

export const SCROLL_Y_NO_BANNER_L = 340;
export const SCROLL_Y_NO_BANNER_M = 215;
